// core components
// import GridItem from "components/Grid/GridItem.js";
import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Container,
  Grid,
  makeStyles,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import CardHeader from "components/Card/CardHeader";
import Card from "components/Card/Card";
// Formik form
import { useFormik } from "formik";
import * as yup from "yup";
import TextField from "@material-ui/core/TextField";
import CardBody from "components/Card/CardBody";
import { useDispatch, useSelector } from "react-redux";
import { loadingProducts } from "store/effects/productsEffect";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { theme } from "components/Theme/Theme";
import { editFormat } from "store/effects/productsEffect";

const styles = {
  typo: {
    paddingLeft: "25%",
    marginBottom: "40px",
    position: "relative",
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: "10px",
    color: "#c0c1c2",
    display: "block",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "13px",
    left: "0",
    marginLeft: "20px",
    position: "absolute",
    width: "260px",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "400",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  uploadImage: {
    "& .MuiButton-label": {
      color: theme.palette.primary.main,
    },
  },
};

const useStyles = makeStyles(styles);
const validationSchema = yup.object({
  label: yup
    .string("Enter the product's format name")
    .required("Format's name is required"),
  reference: yup
    .string("Enter the Format's reference")
    .required("The Format's reference is required"),
  price: yup
    .number("Enter a Format's valid price")
    .required("The Format's price is required"),
});

export default function EditFormatForm(props) {
  const classes = useStyles();
  const {
    productsList: { results },
    loading_products_request,
    edit_format_request,
  } = useSelector((state) => state.products);
  const { format } = props;
  const [value, setValue] = useState(format.product);
  const [image, setImage] = useState();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      label: format.label,
      reference: format.reference,
      price: format.price,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(JSON.stringify(values, null, 2));
      let formData = new FormData();
      formData.append("label", values.label);
      formData.append("reference", values.reference);
      formData.append("price", values.price);
      if (image) {
        formData.append("image", image);
      }
      if (value) {
        formData.append("product", value.id);
      }
      dispatch(editFormat(format.id, formData));
    },
  });
  const handleInputImage = (event) => {
    console.log("Changed");
    const files = event.target.files[0];
    setImage(files);
  };
  const handleSearch = (value) => {
    dispatch(loadingProducts(value ?? ""));
  };
  useEffect(() => {
    dispatch(loadingProducts(""));
  }, []);
  return (
    <GridContainer>
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Edit product&apos;s format</h4>
          <p className={classes.cardCategoryWhite}>
            You are editing a product format
          </p>
        </CardHeader>
        <CardBody>
          <Container>
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={6}>
                  <TextField
                    fullWidth
                    id="label"
                    name="label"
                    label="Format's label *"
                    variant="outlined"
                    value={formik.values.label}
                    onChange={formik.handleChange}
                    error={formik.touched.label && Boolean(formik.errors.label)}
                    helperText={formik.touched.label && formik.errors.label}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    fullWidth
                    id="reference"
                    name="reference"
                    label="Format's reference *"
                    variant="outlined"
                    value={formik.values.reference}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.reference &&
                      Boolean(formik.errors.reference)
                    }
                    helperText={
                      formik.touched.reference && formik.errors.reference
                    }
                  />
                </Grid>
                <Grid item md={6}>
                  <Autocomplete
                    value={value}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                      console.log("newValue ========>", newValue);
                    }}
                    loading={loading_products_request}
                    // inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      handleSearch(newInputValue);
                    }}
                    id="controllable-states-demo"
                    options={results}
                    // style={{ width: 300 }}
                    getOptionLabel={(option) => option.name}
                    renderOption={(option) => (
                      <React.Fragment> {option.name} </React.Fragment>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select a product *"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                <Grid item md={6}>
                  <TextField
                    fullWidth
                    id="price"
                    type={"number"}
                    name="price"
                    label="Format's default price *"
                    variant="outlined"
                    value={formik.values.price}
                    onChange={formik.handleChange}
                    error={formik.touched.price && Boolean(formik.errors.price)}
                    helperText={formik.touched.price && formik.errors.price}
                  />
                </Grid>
                <Grid item md={12}>
                  <input
                    accept="image/*"
                    hidden
                    id={"contained-button-file-" + format.id}
                    // multiple
                    type="file"
                    onChange={handleInputImage}
                  />
                  <label htmlFor={"contained-button-file-" + format.id}>
                    <Button
                      className={classes.uploadImage}
                      variant="outlined"
                      color="primary"
                      component="span"
                    >
                      Upload an image
                    </Button>
                  </label>
                  {image && <p>{image.name}</p>}
                </Grid>
                <Grid item md={12}>
                  {format.image && format.image["0"] !== "/" && (
                    <img src={format.image} width={"80px"} alt={format.name} />
                  )}
                </Grid>
                <Grid item>
                  <Button
                    disabled={edit_format_request}
                    type={"submit"}
                    variant="contained"
                    color="primary"
                  >
                    Edit format{" "}
                    {edit_format_request && <CircularProgress size={14} />}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Container>
        </CardBody>
      </Card>
    </GridContainer>
  );
}
